"use client";

import { type JSX } from "react";
import { ColumnSplitterBase } from "./ColumnSplitterBase";
import { SplitterProps } from "components/sxa/column-splitter/column-splitter.props";

export const Default = (props: SplitterProps): JSX.Element => {
  console.log("---->[TwoColumnSplitter] Component", props.params);

  return (
    <ColumnSplitterBase
      {...props}
      config={{ variantName: "two", defaultEnabledPlaceholders: "1,2" }}
    />
  );
};